import type { SelectProps } from '@ztechapps/webui.input'
import { OptionComponent, Select } from '@ztechapps/webui.input'
import * as React from 'react'
import { useTaxPresetsSetting } from './useTaxPresetsSetting'

export const Option = (props) => {
  const label = <div className="h6 m-0">{props?.label}</div>
  return <OptionComponent {...props} label={label} />
}

export type TaxTemplateSelectProps = {
  appSettingKey?: string
} & SelectProps

export const TaxTemplateSelect = ({ appSettingKey = 'TAX_PRESETS', ...rest }: TaxTemplateSelectProps) => {
  const { taxPresets } = useTaxPresetsSetting({ appSettingKey })

  return (
    <Select
      {...{
        ...rest,
        options: taxPresets,
        placeholder: 'Search for tax preset.',
        components: {
          Option,
        },
      }}
    />
  )
}
